import { useState, useEffect } from "react";
import "../styles/PanelConfig.css";
// import "./ComandosTelegram/styles/gruposTelegram.css";
import Search from "../../generales/Search";
import Modal from "react-modal";
import { useFetch } from '../../../hooks/useFetch';
// import Action from "../Action";
import Action from "../../Action";
import LoadSimple from "../../LoadSimple";
import TableComandosTelegram from "./ComandosTelegram/TableComandosTelegram";
import Paginador from "../../generales/Paginador";
// import ModalCreateTech from "./GruposTelegram/ModalCreateTech";
// import ImportInfo from "./GruposTelegram/ImportInfo";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css'; 
import isAfter from 'date-fns/isAfter';
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
import { addHours, subHours, addDays, subDays, startOfWeek, endOfWeek, startOfMonth, endOfMonth, addMonths } from 'date-fns';
import SelectorAdmin from "../../SelectorAdmin";
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "40%",
    padding: "20px",
  },
};
const ImportModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "70%",
    padding: "20px",
  },
};
const PanelComandosTelegram = ({ server,languaje,mode,handleShowPopup }) => {
  // const limitList = 200;
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const [ImportModalOpen, setImportModalOpen] = useState(false);
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? dataUsers.data : searchResults;
  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });
  // const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [searchResult, setSearchResult] = useState(null);
  const [contRowsSelected,setContRowSelected]=useState(0)
  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [data, setData] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataCis, setDataCis] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);
  const [cisSelected, setCisSelected] = useState([]);
  const [groupSelected,setgroupSelected]=useState([])
  const [poolRows,setPoolRows]=useState([])
  const [allSelected, setAllSelected] = useState(false);
  const [exportLoading,setExportLoading]=useState(false)



  // const [opciones,setOpciones]=useState({user_email:"",module_id:0,fecha_ini:''+obtenerPrimerDiaDelMes(),fecha_fin:''+obtenerFechaActualLocal()})
  //  console.log(opciones)
  useEffect(() => {
    setPageActual(1);
  }, [dataList]);




  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setSearchResult(`Resultados para: ${query}`);
  };
  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateCisModalOpen(true);
  };
  function closCreateCisModal() {
    setSearchTerm("")
    setEditActive(false);
    setCreateCisModalOpen(false);
  }
  const import_info = () => {

    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setImportModalOpen(true);
   
  };
  function closeImportModal() {
    setSearchTerm("")
    setImportModalOpen(false);
    setAllSelected(false)
    setPoolRows([])
  }
  const handleChangEdit = (element) => {
    setgroupSelected(element)
    setEditActive(true);
    setCreateCisModalOpen(true)
  };
  useEffect(() => {
    // search_devices();
  }, []);


  const buscar_cis = () => {
    setLoadingList(true)
    
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url+'/api/v1/cassia/media/telegram/get_last_commands',
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        if (response.ok) {
          const data1 = await response.json();
          setLoadingList(false)
          setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };




  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };


  const [importLoading, setImportLoading] = useState(false);

  return (
    <>
      <div className='head-cis' >
       <div className='title-cis'>
                   <Search
                       searchResults={searchResults}
                       setSearchResults={setSearchResults}
                       searchTerm={searchTerm}
                       setSearchTerm={setSearchTerm}
                       onSearch={handleSearch}
                       dataObject={dataUsers.data}
                       setDataObject={setDataUsers}
                       searchResult={searchResult}
                       setSearchResult={setSearchResult}
                       languaje={languaje}
                     />
             <div className={"cont-result-registers"+mode}>
            
                     <p style={{  textAlign: "center" }}>
                       &nbsp;
                       {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                         dataList.length +
                         ") " 
                         }
                     </p> 
             </div>
              <div className="cont-buttons-panel gruposTelegram">
                     
                       {/* <Action
                       disabled={false}
                       origen="Azul"
                       titulo={"+ "+capitalizeFirstLetter(lang[languaje]['descubrirNuevosGrupos'])}
                       action={import_info}
                     /> */}
                     
                     
                   </div>
                  {/* <div className="cont-buttons-panel" style={{right:'15%'}}>
                     
                    
                   
                   
                   <Action
                       disabled={false}
                       origen="Cielo"
                       titulo={" "+capitalizeFirstLetter(lang[languaje]['importar'])}
                       action={import_info}
                     />
    
                 </div> */}
                   </div>
                   
               </div>
      <div className='cont-cis' >
      <>
<div className="main-panel-cis">
<div className="compact-content-portafolio">
<div className={"content-portafolio-head"+mode}>
  {
  // (contRowsSelected!=0)?
    <>
    {(exportLoading)?<div className="cont-excels-buttons-portafolio cont-result-registers"  style={{position:'absolute'}}>{capitalizeFirstLetter(lang[languaje]['descargando'])}. . .</div>:
    <>
    {/* {(contRowsSelected==0)?<div className="cont-excels-buttons-portafolio" style={{position:'absolute',background:'#62626233',zIndex:'2'}}></div>:''} */}
    {/* <div className="cont-excels-buttons-portafolio" style={{position:'absolute'}}>
    <div className="half-excels-buttons-portafolio">
                  
                  <div className="body-half-excels-buttons-portafolio">
                  {
                    
                    <img
              className="img-dwnld-portafolio"
              src={"/iconos/csv_icon.png"}
              name="regresar"
              onClick={()=>Exportar('csv')}
              style={{opacity:(contRowsSelected==0)? '0.3':'1',
                pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
            />
                  }
                  </div>
                  <div className={"top-half-excels-buttons-portafolio"+mode} >
                    {'CSV  '}
                  </div>
                </div>
               <div className="half-excels-buttons-portafolio">
                  
                  <div className="body-half-excels-buttons-portafolio">
                  {
                    
                    <img
              className="img-dwnld-portafolio"
              src={"/iconos/json_icon.png"}
              name="regresar"
              onClick={()=>Exportar('json')}
              style={{opacity:(contRowsSelected==0)? '0.3':'1',
                pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
            />
                  }
                  </div>
                  <div className={"top-half-excels-buttons-portafolio"+mode} >
                    {'JSON'}
                  </div>
                </div>
                <div className="half-excels-buttons-portafolio">
                
                  <div className="body-half-excels-buttons-portafolio">
                  {
                    
                    <img
              className="img-dwnld-portafolio"
              src={"/iconos/xsl_icon.png"}
              name="regresar"
              onClick={()=>Exportar('excel')}
              style={{opacity:(contRowsSelected==0)? '0.3':'1',
                pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
            />
                  }
                  </div>
                  <div className={"top-half-excels-buttons-portafolio"+mode} >
                  {'EXCEL'}
                  </div>
                </div>
           </div> */}
     </>
    }
    </>
    // :''
        }
        </div>
  <div className="content-portafolio">
    <div className="cont-portafolio-table">
      <div className="content-card-portafolio" id="content">
        {(exportLoading || importLoading) ? (
          <LoadSimple />
        ) : (
          <>
            {cisSelected.length === 0 ? (
              <TableComandosTelegram
                pageActual={pageActual}
                 limitList={limitList} startLimit={startLimit}
                dataList={dataList}
                cisSelected={cisSelected}
                setCisSelected={setCisSelected}
                registerIsValid={registerIsValid}
                searchResults={searchResults}
                setSearchResults={setSearchResults}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                dataUsers={dataUsers}
                setDataUsers={setDataUsers}
                server={server}
                setRegisterIsValid={setRegisterIsValid}
                setData={setData}
                setLoading={setLoading}
                setError={setError}
                handleChangEdit={handleChangEdit}
                devices={devices}
                languaje={languaje}
                mode={mode}
                setContRowSelected={setContRowSelected}
                poolRows={poolRows}
                setPoolRows={setPoolRows}
                allSelected={allSelected}
                setAllSelected={setAllSelected}
                handleShowPopup={handleShowPopup}
                buscar_cis={buscar_cis}
                loadingList={loadingList}
              ></TableComandosTelegram>
            ) : (
              ("")
              // <InfoPortafolio
              //   server={server}
              //   portfolioSelected={cisSelected}
              //   searchResults={searchResults}
              //   setSearchResults={setSearchResults}
              //   searchTerm={searchTerm}
              //   setSearchTerm={setSearchTerm}
              //   onSearch={handleSearch}
              //   dataUsers={dataUsers}
              //   setDataUsers={setDataUsers}
              //   setCisSelected={setCisSelected}
              //   registerIsValid={registerIsValid}
              // ></InfoPortafolio>
            )}
          </>
        )}
      </div>
    </div>

    </div>
    <div className={"content-portafolio-footer"+mode}>
    <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
      
      <div className={"cont-half-display-paginador"+mode}>
      <p style={{  textAlign: "center" }}>
                      &nbsp;
                      {(contRowsSelected!=0)?"("+contRowsSelected+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados']):''}
                </p> 
            
      </div>
    </div>  
    <div className="cont-display-paginador">
              <Paginador  pages={pages}
                          pageActual={pageActual}
                          setPageActual={setPageActual}
                          mode={mode}></Paginador>
    </div>
    <div className="cont-display-paginador">
      <div className={"cont-half-display-paginador"+mode}>
                
      <div>
<label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
<select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
  <option value={10}>10</option>
  <option value={50} >50</option>
  <option value={100}>100</option>
  <option value={500}>500</option>
  <option value={1000}>1000</option>
</select>


</div>
      </div>
      <div className={"cont-half-display-paginador"+mode}>
      <p style={{  textAlign: "center" }}>
                      &nbsp;
                      {"(" +
                  (startLimit + 1) +
                  " - " +
                  (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                    ?  parseInt(pageActual ) * parseInt(limitList)
                    : dataList.length) +
                  ")  "+lang[languaje]['de']+" " +
                  dataList.length +
                  " "+lang[languaje]['resultados']}
                </p>
            
      </div>
    </div>  
              
  </div>
  </div>
</div>
<Modal
  isOpen={CreateCisModalOpen}
  // isOpen={false}
  // onAfterOpen={afterOpenExeption}
  onRequestClose={closCreateCisModal}
  style={CreateCisModalStyles}
  contentLabel="Example Modal2"
  // shouldCloseOnOverlayClick={false}
>
{/* <ModalCreateTech
devices={devices}
server={server}
editActive={editActive}
setEditActive={setEditActive}
dataCis={dataCis}
setData={setData}
loading={loading}
setLoading={setLoading}
setError={setError}
dataUsers={dataUsers}
setRegisterIsValid={setRegisterIsValid}
closCreateCisModal={closCreateCisModal}
groupSelected={groupSelected}
languaje={languaje}
mode={mode}
setSearchTerm={setSearchTerm}
handleShowPopup={handleShowPopup}
></ModalCreateTech> */}
</Modal>

<Modal
  isOpen={ImportModalOpen}
  // isOpen={false}
  // onAfterOpen={afterOpenExeption}
  onRequestClose={closeImportModal}
  style={ImportModalStyles}
  contentLabel="Example Modal2"
  shouldCloseOnOverlayClick={false}
>
{/* <ImportInfo
server={server}
importLoading={importLoading}
setImportLoading={setImportLoading}
closeImportModal={closeImportModal}
languaje={languaje}
mode={mode}
handleShowPopup={handleShowPopup}
buscar_cis={buscar_cis}
></ImportInfo> */}
</Modal>
</>
          
      </div>
    </>
  );
};

export default PanelComandosTelegram;
